import React, { useEffect, useRef } from 'react';
import { ResourceTree } from './ResourceTree';
import { TimelineHeader } from './TimelineHeader';
import { TimelineGrid } from './TimelineGrid';
import type { SchedulerProps } from '../../types';
import { SchedulerProvider } from './SchedulerContext';

const SchedulerLayout: React.FC<{ onScrollBottom?: () => void }> = ({ onScrollBottom }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop - clientHeight < 50) {
      if (onScrollBottom) onScrollBottom();
    }
  };

  return (
    <div className="d-flex flex-column h-100 bg-white border rounded shadow overflow-hidden">
      <div className="d-flex flex-grow-1 overflow-hidden position-relative">
        <ResourceTree />
        <div className="flex-grow-1 d-flex flex-column overflow-hidden position-relative">
          <div
            ref={scrollContainerRef}
            className="overflow-auto flex-grow-1 position-relative bg-white"
            id="timeline-scroll-container"
            onScroll={handleScroll}
            style={{
              scrollbarWidth: 'thick' as React.CSSProperties['scrollbarWidth'],
              scrollbarColor: '#bbb #f1f1f1',
            }}
          >
            <TimelineHeader />
            <TimelineGrid />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Scheduler: React.FC<SchedulerProps> = (props) => {
  return (
    <SchedulerProvider {...props}>
      <SchedulerLayout onScrollBottom={props?.onScrollBottom} />
    </SchedulerProvider>
  );
};